import React from 'react';
import {
  Router as DefaultRouter,
  Route,
  Switch,
  StaticRouter,
} from 'react-router-dom';
import dynamic from 'umi/dynamic';
import renderRoutes from 'umi/lib/renderRoutes';
import history from '@@/history';
import { routerRedux } from 'dva';

const Router = routerRedux.ConnectedRouter;

const routes = [
  {
    path: '/',
    component: require('../../layouts/index.js').default,
    routes: [
      {
        path: '/404',
        exact: true,
        component: require('../404.jsx').default,
      },
      {
        path: '/airport',
        exact: true,
        component: require('../airport/index.tsx').default,
      },
      {
        path: '/airport/motion',
        exact: true,
        component: require('../airport/motion/index.jsx').default,
      },
      {
        path: '/buy',
        exact: true,
        component: require('../buy/index.jsx').default,
      },
      {
        path: '/cip',
        exact: true,
        component: require('../cip/index.jsx').default,
      },
      {
        path: '/cip/networkDetail',
        exact: true,
        component: require('../cip/networkDetail/index.jsx').default,
      },
      {
        path: '/cip/recordList',
        exact: true,
        component: require('../cip/recordList/index.jsx').default,
      },
      {
        path: '/home/bankcomm',
        exact: true,
        component: require('../home/bankcomm.jsx').default,
      },
      {
        path: '/home',
        exact: true,
        component: require('../home/index.jsx').default,
      },
      {
        path: '/',
        exact: true,
        component: require('../index.js').default,
        Author: 'zhanghj',
        Date: '2020-09-08T10:16:08.000Z',
        LastEditors: 'zhanghj',
        LastEditTime: '2021-01-07T14:19:29.000Z',
      },
      {
        path: '/login',
        exact: true,
        component: require('../login/index.jsx').default,
      },
      {
        path: '/lounge',
        exact: true,
        component: require('../lounge/index.tsx').default,
      },
      {
        path: '/lounge/motion',
        exact: true,
        component: require('../lounge/motion/index.jsx').default,
      },
      {
        path: '/meal/detail',
        exact: true,
        component: require('../meal/detail/index.jsx').default,
      },
      {
        path: '/meal',
        exact: true,
        component: require('../meal/index.jsx').default,
      },
      {
        path: '/meal/networkDetail',
        exact: true,
        component: require('../meal/networkDetail/index.jsx').default,
      },
      {
        path: '/pay',
        exact: true,
        component: require('../pay/index.jsx').default,
      },
      {
        path: '/payFinish',
        exact: true,
        component: require('../payFinish/index.jsx').default,
      },
      {
        path: '/railSetMeal/common/enum',
        exact: true,
        component: require('../railSetMeal/common/enum.ts').default,
      },
      {
        path: '/railSetMeal/common/util',
        exact: true,
        component: require('../railSetMeal/common/util.ts').default,
      },
      {
        path: '/railSetMeal',
        exact: true,
        component: require('../railSetMeal/index.tsx').default,
      },
      {
        path: '/rechargePoint/orderInfo',
        exact: true,
        component: require('../rechargePoint/orderInfo.jsx').default,
      },
      {
        path: '/record',
        exact: true,
        component: require('../record/index.jsx').default,
      },
      {
        path: '/search',
        exact: true,
        component: require('../search/index.jsx').default,
      },
      {
        path: '/step',
        exact: true,
        component: require('../step/index.jsx').default,
        Description: null,
        Author: 'zhanghj',
        Date: '2020-09-28T09:38:14.000Z',
        LastEditors: 'zhanghj',
        LastEditTime: '2021-01-07T14:18:48.000Z',
      },
      {
        path: '/test/TextArea',
        exact: true,
        component: require('../test/TextArea/index.js').default,
        Author: 'zhanghj',
        Date: '2020-09-27T10:59:11.000Z',
        LastEditors: 'zhanghj',
        LastEditTime: '2020-09-27T17:53:12.000Z',
      },
      {
        path: '/test',
        exact: true,
        component: require('../test/index.js').default,
        Author: 'zhanghj',
        Date: '2020-09-27T10:58:42.000Z',
        LastEditors: 'zhanghj',
        LastEditTime: '2020-09-27T17:51:34.000Z',
      },
      {
        path: '/use/getQrcode',
        exact: true,
        component: require('../use/getQrcode.js').default,
      },
      {
        path: '/use',
        exact: true,
        component: require('../use/index.jsx').default,
      },
      {
        path: '/use/traceId',
        exact: true,
        component: require('../use/traceId.js').default,
      },
      {
        path: '/use/unionPay',
        exact: true,
        component: require('../use/unionPay.jsx').default,
      },
      {
        component: require('../404.jsx').default,
      },
    ],
  },
];
window.g_routes = routes;
const plugins = require('umi/_runtimePlugin');
plugins.applyForEach('patchRoutes', { initialValue: routes });

export { routes };

export default class RouterWrapper extends React.Component {
  unListen() {}

  constructor(props) {
    super(props);

    // route change handler
    function routeChangeHandler(location, action) {
      plugins.applyForEach('onRouteChange', {
        initialValue: {
          routes,
          location,
          action,
        },
      });
    }
    this.unListen = history.listen(routeChangeHandler);
    // dva 中 history.listen 会初始执行一次
    // 这里排除掉 dva 的场景，可以避免 onRouteChange 在启用 dva 后的初始加载时被多执行一次
    const isDva =
      history.listen
        .toString()
        .indexOf('callback(history.location, history.action)') > -1;
    if (!isDva) {
      routeChangeHandler(history.location);
    }
  }

  componentWillUnmount() {
    this.unListen();
  }

  render() {
    const props = this.props || {};
    return <Router history={history}>{renderRoutes(routes, props)}</Router>;
  }
}
